import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from "react-oidc-context";

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const baseUrl = isLocalhost ? 'http://localhost:3000' : `${window.location.protocol}//${window.location.hostname}`;
const redirectUri = `${baseUrl}/home`;

const cognitoAuthConfig = {
  authority: "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_3n9j6gDzL",
  client_id: "2c6na652k2lkcsaa1ol8m5chp4",
  redirect_uri: redirectUri,
  response_type: "code",
  scope: "phone openid email profile",
  // 确保在登录后自动处理回调
  automaticSilentRenew: true,
  onSigninCallback: () => {
    // 清理 URL 中的 code 和 state 参数
    window.history.replaceState({}, document.title, '/home');
  },
};
// Create root and render App
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);